import React from 'react';
import { useParams } from 'react-router-dom';

import PanelDev from 'panels/dev/PanelDev';

import PanelOrgList from 'panels/orgs/PanelOrgList';
import PanelOrgInfo from 'panels/orgs/PanelOrgInfo';
import PanelOutletInfo from 'panels/orgs/PanelOutletInfo';

export default function LayoutOutlet() {

    const { page } = useParams();

    return (
        <>
            <div className='h-screen w-full'>
                {
                    (() => {
                        switch (page) {
                            case 'outlet':
                                return (<PanelOrgList />);
                            case 'orgInfo':
                                return (<PanelOrgInfo />);
                            case 'outletInfo':
                                return (<PanelOutletInfo />);
                            default:
                                return (<PanelDev />);
                        }
                    })()
                }
            </div>
        </>
    )
}
